module.exports = __webpack_public_path__ + "img/underline.3a8023ce.svg";